import { GRID_COMBO_EDITOR_DEFAULTS } from "../../../other/configs/globalConfig.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import {
  tagWidget,
  tagWidgetForEach
} from "../../../other/utils/otherUtils.jsx";
import { getCustomGroupRenderer } from "../../../other/utils/utils.jsx";
import SwivuSortColumn from "../SwivuSortColumn.jsx";

// the base super class for all child tags classes, such as TaskTag, ResourceTag and ClientTag
export default class TagColumnBase extends SwivuSortColumn {
  static get $name() {
    return "TagColumnBase";
  }

  get swivuIsTagColumn() {
    return true;
  }

  static get defaults() {
    return {
      cellCls: "tag-tag-col-cls",
      groupRenderer(event) {
        return getCustomGroupRenderer(event);
      },
      editor: {
        ...TagColumnBase.defaultFilterableOptions
      },
      filterType: "_swivu_settings"
    };
  }

  static defaultFilterableOptions = {
    valueField: "id",
    displayField: "tagValue",
    onSwivuEditMessage: "onClickSwivuEditMessage",
    ...GRID_COMBO_EDITOR_DEFAULTS
  };

  onLoad(project, otherParams) {
    super.onLoad(project);
    this.project = project;
    this.editorHandler = otherParams.editorHandler;
  }

  get swivuListItems() {
    return this.getTagRecords(this.project);
  }

  getSwivuListItemDisplayValue(record) {
    return record.tagValue;
  }

  onSwivuListSelectionChange(record, newTagRecord) {
    if(this.canMultiSelectSwivuList) {
      record[this.tagRecordKey] = newTagRecord.map((item) => item.id);
      return;
    }
    record[this.tagRecordKey] = newTagRecord[0]?.id;
  }

  getSelectedSwivuListItem(record) {
    if(this.canMultiSelectSwivuList) {
      return this.swivuListItems.filter((item) => (
        record[this.tagRecordKey]?.map((item) => item.id).includes(item.id)
      ))
    }
    return record[this.tagRecordKey]?.id;
  }

  onSwivuManageList() {
    this.editorHandler.openEditor(
      EDITOR_KEYS.settingGeneralEditor,
      null,
      {
        selectTabByTypeOnOpen: this.tabName
      },
      { by: "recordType", useExisting: true }
    );
  }

  getTagRecords(project) {
    if (project[this.storeKey]) {
      return project[this.storeKey].query((s) => s.tagSet === this.tagKey, true);
    }
  }

  getDefRenderer(record) {
    return record && record.length ? tagWidgetForEach(record) : tagWidget(record?.tagValue);
  }

  defaultRenderer({ record }) {
    return this.getDefRenderer(record[this.tagRecordKey]);
  }

  /**
   *
   * @param {object|objects[]|null} recordId
   * @param value
   * @return {boolean|*}
   */
  static isMatchValues(recordId, value) {
    if (recordId) {
      if (Array.isArray(recordId)) {
        if (recordId.length) return recordId.includes(value);
      } else {
        return recordId === value;
      }
    }
    return false;
  }

  // according to docs this is specifically called by renderer and group renderer
  // but here we need it to be overridden for global search
  formatValue(record) {
    if (Array.isArray(record)) return record.join(" ");
    return record;
  }
}

TagColumnBase.initClass();
